import { OptionDto } from "@/dtos";
import { DeviceStatus } from "@/helpers/types";

const statusDevice = [
    { value: parseInt(DeviceStatus.FREE), label: 'LIBRE' },
    { value: parseInt(DeviceStatus.OCCUPIED), label: 'OCUPADO' },
    // { value: parseInt(DeviceStatus.REPAIR), label: 'REPARACIÓN' },
    // { value: parseInt(DeviceStatus.DAMAGED), label: 'DAÑADO' }
] as OptionDto[];

export const getStatusDeviceOption = (): OptionDto[] => {
    return statusDevice;
}

export const getDeviceStatus = (value: number): OptionDto => {
    return statusDevice.find((x) => x.value == value) ?? statusDevice[0];
}

export const getStatusDevice = (value: number): DeviceStatus => { 
    switch (value) {
        case 1001:
            return DeviceStatus.FREE;
        case 1002:
            return DeviceStatus.OCCUPIED;
        // case 1003:
        //     return DeviceStatus.REPAIR;
        // case 1004:
        //     return DeviceStatus.DAMAGED; 
        default:
            return DeviceStatus.FREE;
    }
}